import { NodeType } from '@amplify/amp-module';

import { NodeSizes } from '@/constants/builder';

import GoToNode from '@/components/graph/nodes/GoToNode';
import OpenNode from '@/components/graph/nodes/OpenNode';
import StartNode from '@/components/graph/nodes/StartNode';
import PlayerNode from '@/components/graph/nodes/PlayerNode';
import MessageNode from '@/components/graph/nodes/MessageNode';
import NodePreview from '@/components/graph/nodes/NodePreview';
import ConditionNode from '@/components/graph/nodes/ConditionNode';
import PluginNode from '@/components/graph/nodes/plugin-node/PluginNode';
import CarouselNode from '@/components/graph/nodes/groups/carousel/CarouselNode.vue';
import ButtonNode from '@/components/graph/nodes/groups/button/ButtonNode.vue';
import QuestionNode from '@/components/graph/nodes/groups/question/QuestionNode.vue';

export default {
  [NodeType.buttonGroup]: {
    shape: `${NodeType.buttonGroup}-node`,
    width: NodeSizes[NodeType.buttonGroup].width,
    height: NodeSizes[NodeType.buttonGroup].height,
    component: {
      template: `<ButtonNode :context="context" />`,
      components: {
        ButtonNode,
      },
    },
  },

  [NodeType.carousel]: {
    shape: `${NodeType.carousel}-node`,
    width: NodeSizes[NodeType.carousel].width,
    height: NodeSizes[NodeType.carousel].height,
    component: {
      template: `<CarouselNode :context="context" />`,
      components: {
        CarouselNode,
      },
    },
  },

  [NodeType.condition]: {
    shape: `${NodeType.condition}-node`,
    width: NodeSizes[NodeType.condition].width,
    height: NodeSizes[NodeType.condition].height,
    component: {
      template: `<ConditionNode :context="context" />`,
      components: {
        ConditionNode,
      },
    },
  },

  [NodeType.goTo]: {
    shape: `${NodeType.goTo}-node`,
    width: NodeSizes[NodeType.goTo].width,
    height: NodeSizes[NodeType.goTo].height,
    component: {
      template: `<GoToNode :context="context" />`,
      components: {
        GoToNode,
      },
    },
  },

  [NodeType.message]: {
    shape: `${NodeType.message}-node`,
    width: NodeSizes[NodeType.message].width,
    height: NodeSizes[NodeType.message].height,
    component: {
      template: `<MessageNode :context="context" />`,
      components: {
        MessageNode,
      },
    },
  },

  [NodeType.open]: {
    shape: `${NodeType.open}-node`,
    width: NodeSizes[NodeType.open].width,
    height: NodeSizes[NodeType.open].height,
    component: {
      template: `<OpenNode :context="context" />`,
      components: {
        OpenNode,
      },
    },
  },

  [NodeType.plugin]: {
    shape: `${NodeType.plugin}-node`,
    width: NodeSizes[NodeType.plugin].width,
    height: NodeSizes[NodeType.plugin].height,
    component: {
      template: `<PluginNode :context="context" />`,
      components: {
        PluginNode,
      },
    },
  },

  [NodeType.question]: {
    shape: `${NodeType.question}-node`,
    width: NodeSizes[NodeType.question].width,
    height: NodeSizes[NodeType.question].height,
    component: {
      template: `<QuestionNode :context="context" />`,
      components: {
        QuestionNode,
      },
    },
  },

  [NodeType.player]: {
    shape: `${NodeType.player}-node`,
    width: NodeSizes[NodeType.player].width,
    height: NodeSizes[NodeType.player].height,
    component: {
      template: `<PlayerNode :context="context" />`,
      components: {
        PlayerNode,
      },
    },
  },

  start: {
    shape: 'start-node',
    width: NodeSizes.start.width,
    height: NodeSizes.start.height,
    component: {
      template: `<StartNode :context="context" />`,
      components: {
        StartNode,
      },
    },
  },

  preview: {
    shape: 'preview-node',
    width: NodeSizes.preview.width,
    height: NodeSizes.preview.height,
    component: {
      template: `<NodePreview :context="context" />`,
      components: {
        NodePreview,
      },
    },
  },
};
